import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { personalKeyGroups } from 'modules/contracts/lib/germanContractData'

interface Props {
  personalKeyGroupId?: number | null
}

const PersonalKeyGroup = ({ personalKeyGroupId }: Props) => {
  const personalKeyGroup = personalKeyGroupId ? personalKeyGroups()[personalKeyGroupId] : undefined
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.germany.personal_key_group')}
      description={personalKeyGroup}
    />
  )
}

export default observer(PersonalKeyGroup)
